<ion-content no-bounce>
  <app-header
    [iconName]="'menu'"
    [title]="null"
    [menuToggleRight]="true"
    [showErrorMessageNetwork]="true">
  </app-header>

  <div class="error-network" *ngIf="!isOnline()">
    <span class="error-network-container">
      <i class="icon-warning"></i>
      <span>{{"NoAccessInternet" | translate}}</span>
    </span>
  </div>

  <div class="document-print" *ngIf="isOnline()">

    <!-- ── Step 1: Select file ── -->
    <div class="document-print__section">
      <h3 class="document-print__section-title">{{"SelectFile" | translate}}</h3>

      <label
        class="document-print__dropzone"
        [ngClass]="{'document-print__dropzone--active': isDragOver()}"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave()"
        (drop)="onDrop($event)">

        <i class="icon-upload document-print__dropzone-icon"></i>

        <span *ngIf="!selectedFile()">
          {{"Drag File Here" | translate}}
        </span>
        <span *ngIf="selectedFile()" class="document-print__filename">
          {{ selectedFile().name | sanitizeText }}
        </span>

        <input
          type="file"
          accept=".pdf,application/pdf"
          (change)="onFileInputChange($event)"
          class="document-print__file-input">
      </label>

      <div class="document-print__validation-error" *ngIf="validationError()">
        <i class="icon-close text-danger"></i>
        <span>{{ validationError() | translate }}</span>
      </div>
    </div>

    <!-- ── Step 2: Select queue ── -->
    <div class="document-print__section">
      <h3 class="document-print__section-title">{{"SelectPrinter" | translate}}</h3>

      <div class="printer-list-actions">
        <ion-toolbar class="printer-list-search-toolbar">
          <ion-searchbar
            class="printer-list-searchbar"
            show-clear-button="always"
            placeholder="{{'Search' | translate}}"
            [debounce]="500"
            (ionInput)="onSearch($event)">
          </ion-searchbar>
        </ion-toolbar>
        <div class="selected-networks-container">
          <div class="selected-networks-container__selected-networks">
            <div class="selected-network" *ngFor="let filter of storedNetworkFilters()">
              <div class="selected-network__content" *ngIf="filter">
                {{filter['name']}} <button class="dismissSelectedFilter" (click)="dismissSelectedFilter(filter)"><span>x</span></button>
              </div>
            </div>
          </div>
          <ion-button
            class="selected-networks-container__filter-button"
            fill="outline"
            (click)="presentPopover($event)">
            <span>{{"Filters" | translate}}</span>
            <span class="filter-icon">
              <i class="icon-filter-useful"></i>
            </span>
          </ion-button>
        </div>
      </div>

      <ion-list *ngIf="queueList().length > 0; else noQueues">
        <div class="list list--boxed list--spaced">
          <ion-item class="queue-list-item" *ngFor="let queue of queueList()">
            <div class="printer-queue-container"
              [ngClass]="{'printer-queue-container--selected': selectedQueue()?.links?.self === queue.links.self}">

              <button class="select-printer-clickzone printer-queue" (click)="onQueueSelect(queue)">
                <div class="printer-id queues-list printer-id--online pull-left"
                  [ngClass]="{'adjust-signId': queue.printerDetails?.colorSupport || queue.printerDetails?.duplexSupport}">
                  <div>{{ queue.signId | sanitizeText }}</div>
                  <div class="printer-features">
                    <div *ngIf="queue.printerDetails?.colorSupport || queue.printerDetails?.duplexSupport">
                      <img class="printer-feature__icon printer-feature--color"
                        title="{{'Color print' | translate}}"
                        *ngIf="queue.printerDetails?.colorSupport"
                        src="https://assets.printix.net/img/v2/icons/printer-features/cmyk.svg"
                        alt="CMYK icon">
                      <img class="printer-feature__icon printer-feature--duplex"
                        title="{{'Two-sided print' | translate}}"
                        *ngIf="queue.printerDetails?.duplexSupport"
                        src="https://assets.printix.net/img/v2/icons/printer-features/duplex.svg"
                        alt="Duplex icon">
                    </div>
                  </div>
                </div>
              </button>

              <button class="select-printer-clickzone printer-queue text" (click)="onQueueSelect(queue)">
                <div class="queue-text pull-left">
                  <div class="queue-name">{{ queue.name | sanitizeText }}</div>
                  <div class="printer-location" *ngIf="queue.printerDetails?.location">{{ queue.printerDetails.location | sanitizeText }}</div>
                </div>
              </button>

              <span class="queue-selected-icon" *ngIf="selectedQueue()?.links?.self === queue.links.self">
                <i class="icon-ok"></i>
              </span>

            </div>
          </ion-item>
        </div>
      </ion-list>

      <ng-template #noQueues>
        <div class="text-center mt20">{{"NoPrinters" | translate}}</div>
      </ng-template>
      <div class="pagination-container printer-list" *ngIf="pagingObject()?.totalPages > 1">
        <button class="btn btn-sm prev" [disabled]="pagingObject()?.number === 0" (click)="pagingObject()?.number > 0 ? getNextPage(true) : false">
          <i class="icon-left-open"></i>
        </button>
        <span class="paging-numerics">{{(pagingObject()?.number ?? 0) + 1}}/{{pagingObject()?.totalPages}}</span>
        <button class="btn btn-sm next" [disabled]="currentPage + 1 >= pagingObject()?.totalPages" (click)="getNextPage()">
          <i class="icon-right-open"></i>
        </button>
      </div>    </div>

  </div>
</ion-content>

<div class="document-print__footer">

  <!-- Idle / ready -->
  <button
    class="btn document-print__upload-btn"
    [disabled]="!canUpload"
    *ngIf="uploadState === 'idle'"
    (click)="onUpload()">
    <i class="icon-upload"></i>
    {{"Upload For Printing" | translate}}
  </button>

  <!-- In progress -->
  <div class="document-print__progress" *ngIf="uploadState === 'initiating' || uploadState === 'uploading' || uploadState === 'confirming'">
    <span class="loader loader--sm loader--compact">
      <span></span>
    </span>
    <span *ngIf="uploadState === 'initiating'">{{"Initiating" | translate}}</span>
    <span *ngIf="uploadState === 'uploading'">{{"Uploading" | translate}}</span>
    <span *ngIf="uploadState === 'confirming'">{{"Confirming" | translate}}</span>
  </div>

  <!-- Error -->
  <div class="document-print__status-error" *ngIf="uploadState === 'error'">
    <i class="icon-close text-danger"></i>
    <span>{{"UploadFailed" | translate}}</span>
    <button class="btn btn--link" (click)="onUpload()">{{"Retry" | translate}}</button>
  </div>

</div>
